var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPxPolish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Polish flag icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.-LFM-flow-\\u2013-Rewe-case",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1a.-Language-selection-\\u2013-LFM-\\u2013-Rewe-\\u2013-mvp",
    transform: "translate(-16.000000, -521.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "::-Body",
    transform: "translate(0.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "px-polish",
    transform: "translate(16.000000, 191.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,12.0000451 C24,13.402564 23.759332,14.7488619 23.31708,16.000005 C21.6699846,20.6607873 17.2249166,24.0000752 11.9999699,24.0000752 C6.77503827,24.0000752 2.3299402,20.6607873 0.682799726,16.000005 C0.240592876,14.7488619 0,13.402564 0,12.0000451 L24,12.0000451",
    id: "Fill-3",
    fill: "#D7210A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,12.0000451 L0,12.0000451 C0,10.5975262 0.240592876,9.25122827 0.682799726,8.00011525 C2.3299402,3.33936298 6.77503827,0 11.9999699,0 C17.2249166,0 21.6699846,3.33936298 23.31708,8.00011525 C23.759332,9.25122827 24,10.5975262 24,12.0000451",
    id: "Fill-4",
    fill: "#EDEDED"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPxPolish);
export default __webpack_public_path__ + "static/media/px-polish.d2019d882146f6812cfd2cd7570dc5c5.svg";
export { ForwardRef as ReactComponent };